import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 bg-white rounded-lg p-4" }
const _hoisted_2 = { class: "text-lg font-semibold text-textPrimary text-left" }
const _hoisted_3 = { class: "text-md text-textPrimary text-left" }
const _hoisted_4 = { class: "flex flex-col gap-4 mt-4" }

import { ref, watch } from 'vue'
import Checkbox from '@/components/designSystem/Checkbox/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxSelect',
  props: {
    modelValue: {},
    title: {},
    description: {},
    options: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const selected = ref<string[]>(props.modelValue)

const onSelect = (payload: { isChecked: boolean; value: string }) => {
  if (payload.isChecked) {
    if (!selected.value.includes(payload.value)) {
      selected.value.push(payload.value)
    }
  } else {
    selected.value = selected.value.filter((v) => v !== payload.value)
  }
  emit('update:modelValue', selected.value)
}

watch(
  () => props.modelValue,
  (newValue) => {
    selected.value = [...newValue]
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.description), 1),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createBlock(Checkbox, {
          key: option.value,
          label: option.label,
          value: option.value,
          fieldId: `checkbox-${option.value}`,
          checked: selected.value.includes(option.value),
          "onUpdate:checked": onSelect
        }, null, 8, ["label", "value", "fieldId", "checked"]))
      }), 128))
    ])
  ]))
}
}

})